module Meevo.Plugins.Employee {
    "use strict";

    /**
    * Location Section of Employee 
    */
    export class LocationSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.UserSecurity> {
        public selectedLocationFilter = false;
        public checkBoxBusinessType: boolean;
        public available: any;
        public locationFilterType = [
            { name: 'Locations', value: false },
            { name: 'Location Group', value: true }
        ];

        public isMeevoBIModuleEnabled: any;
        public moduleResponse = this.dataService.customMethodData('api//Module/TenantList', 'POST', { "TenantId": this.identityService.current().tenantId, "ModuleId": 11044966 }).then(res => {
            this.isMeevoBIModuleEnabled = res.data;
        });

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            appSettings?: Components.Common.IAppSettings,
            sectionSecurityKey?: string,
            translateService?: angular.translate.ITranslateService,
            protected modalService?: Components.Modal.IModalService,
            private context?: Meevo.Components.BaseClasses.IDataMaintenanceContext
        ) {
            super(
                sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings,
                sectionSecurityKey,
                translateService
            )
        };

        activate(): void {

            if (this.context["canLocationAddUser"] < 0) {
                this.modalService.alert("MESSAGE_USER_LIMIT_EXCEEDED_FREEUP");
            }

            super.activate();
        }
        public meevoBISecurityTypes = [
            { name: this.translateService.instant("LABEL_NONE"), value: Model.BISecurityAccessTypeEnum.None },
            { name: this.translateService.instant("CUSTOM_LABEL_EMPLOYEE"), value: Model.BISecurityAccessTypeEnum.Employee },
            { name: this.translateService.instant("LABEL_FULL_LOCATION"), value: Model.BISecurityAccessTypeEnum.FullLocation }
        ];

        newAddLocationDetail: Model.LocationListItem = undefined;
        newAddLocationGroupDetail: Model.LocationGroupListItem = undefined;
        newUserBuinessType: Model.DataDetail = undefined;

        public GetSecurityAccessString(BISecurityAccessType: Model.BISecurityAccessTypeEnum): string {

            if (BISecurityAccessType == Model.BISecurityAccessTypeEnum.FullLocation) {
                return this.translateService.instant("LABEL_FULL_LOCATION");
            }
            else if (BISecurityAccessType == Model.BISecurityAccessTypeEnum.Employee) {
                return this.translateService.instant("CUSTOM_LABEL_EMPLOYEE");
            }
            else {
                return this.translateService.instant("LABEL_NONE");
            }
        }

        // Security Role Management
        isSecurityRoleRequired(locationId: number): boolean {
            return false;
            /*var employee = this.currentEmployee;
                if (Model.Guard.isNothing(employee) || Model.Guard.isNothing(employee.homeLocation))
                    return false;
            	
                return employee.homeLocation.securityRoles.length === 0 && employee.fullAccess === false;
            */
        }

        public sectionModelRetrieved(): void {
            if (this.identityService.inCentralOfficeMode()) {
                let criteria = { UserID: this.identityService.current().userId, ExcludeIdList: this.identityService.userBusinessTypes.length <= 0 ? this.identityService.current().centralOfficeId : null }
                this.dataService.customMethodData('/api/location/List/', 'POST', { criteria: criteria, itemsPerPage: 10000 }).then((res) => {
                    this.available = _.pluck(res.data, 'locationId');
                })
            }
            this.mapSecurityRoleSmartCenter();
        }

        canManageLocation(locationId: number): boolean {
            if (!this.identityService.inCentralOfficeMode())
                return true;

            return _.contains(this.available, locationId);

        }

        addLocation(): void {
            if (Model.Guard.isNothing(this.newAddLocationDetail))
                return;

            if (Model.Guard.isNothing(this.model.userLocations))
                this.model.userLocations = new Array<Model.UserLocation>();


            let loc = _.find(this.model.userLocations, (ul1) => { return ul1.location.id === this.newAddLocationDetail.id });

            if (Model.Guard.isSomething(loc) && loc.location.objectState == Model.ObjectStateEnum.Inactive) {
                loc.location.objectState = Model.ObjectStateEnum.Active;
                return;
            }

            var ul: Model.UserLocation = {
                location: { id: this.newAddLocationDetail.id, displayName: this.newAddLocationDetail.storeName, objectState: Model.ObjectStateEnum.Active },
                securityRoles: [],
                smartCenters: [],
                learningTracks: []
            };

            var locationExists = _.find(this.model.userLocations, (ul) => { return ul.location.id === this.newAddLocationDetail.id });
            if (Model.Guard.isNothing(locationExists))
                this.model.userLocations.push(ul);

            //Set focus to new added 
            var smartcenterid = '#smartcenter' + this.newAddLocationDetail.id;
            window.location.hash = smartcenterid;

            this.newAddLocationDetail = undefined;
        }

        removeLocation(index: number): void {
            if (Model.Guard.isSomething(this.model.userLocations)) {
                this.model.userLocations[index].location.objectState = Model.ObjectStateEnum.Inactive;
                this.model.userLocations[index].securityRoles = [];
                this.model.userLocations[index].smartCenters = [];
                this.model.userLocations[index].learningTracks = [];
            }

        }

        addSecurityRole(location: Model.UserLocation): void {

            if (Model.Guard.isNothing(location) || Model.Guard.isNothing(location.newAddRoleDetail))
                return;

            if (_.any(location.securityRoles, (sr) => { return sr.id === location.newAddRoleDetail.id }))
                return;

            var roleDetail: Model.ObjectStateDataDetail = {
                id: location.newAddRoleDetail.id,
                displayName: location.newAddRoleDetail.displayName,
                objectState: Model.ObjectStateEnum.Active

            };
            location.securityRoles.push(roleDetail);
            this.getRoleSmartCenters([location.newAddRoleDetail.id]).then(smartCenters => {
                smartCenters.forEach(sc => {
                    location.newAddSmartCenterDetail = sc;
                    this.addSmartCenter(location);
                })
            })
            location.newAddRoleDetail = undefined;
        }

        mapSecurityRoleSmartCenter(): void {
            const userLocationRoles = this.model.userLocations.reduce((sets, set) => ([...sets, ...set.securityRoles.map(s => s.id)]), [])
            var userLocationGroupRoles = null;
            if (this.model.userLocationGroups != null) {
                userLocationGroupRoles = this.model.userLocationGroups.reduce((sets, set) => ([...sets, ...set.securityRoles.map(s => s.id)]), [])
            }
            const userRolesIds: string[] = [...userLocationRoles, ...userLocationGroupRoles];
            if (userRolesIds.length === 0) {
                return;
            }
            this.getRoleSmartCenters(userRolesIds).then(roleSmartCenter => {
                roleSmartCenter.forEach(rsc => {
                    this.model.userLocations.forEach( location=>{
                        const role = location.securityRoles.find(sr => sr.id === rsc.role_TId);
                        const index = location.smartCenters.findIndex(sc => sc.id === rsc.id);
                        if(!role){
                            return
                        }
                        if (!!location.smartCenters[index]) {
                            location.smartCenters[index] = { ...location.smartCenters[index], ...rsc, ...{ roleDisplayName: role.displayName } }
                        }
                        else{
                            location.smartCenters.push({...rsc, ...{ roleDisplayName: role.displayName }});
                        }
                    })
                    this.model.userLocationGroups.forEach(locationGroup => {
                        const role = locationGroup.securityRoles.find(sr => sr.id === rsc.role_TId);
                        const index = locationGroup.smartCenters.findIndex(sc => sc.id === rsc.id);
                        if (role && !!locationGroup.smartCenters[index]) {
                            locationGroup.smartCenters[index] = { ...locationGroup.smartCenters[index], ...rsc, ...{ roleDisplayName: role.displayName } }
                        }
                    })
                })
            })
        }

        getRoleSmartCenters(roles: string[]): angular.IPromise<Model.SecurityRoleSmartCenterDataDetail[]> {
            const request = {
                tenantId: this.identityService.current().tenantId,
                RoleId_List: roles
            }
            return this.dataService.customMethodData('api/SecurityRole/SmartCenter', 'POST', request).then(res => {
                return res.data as Model.SecurityRoleSmartCenterDataDetail[];
            })
        }

        removeSecurityRole(location: Model.UserLocation, index: number, item: Model.ObjectStateDataDetail): void {

            if (Model.Guard.isSomething(location.securityRoles)) {
                var i = location.securityRoles.indexOf(item);

                if (i !== -1) {
                    location.smartCenters = location.smartCenters.filter(sc => sc.role_TId !== item.id);
                    location.securityRoles.splice(i, 1);
                }
            }
        }

        addSmartCenter(location: Model.UserLocation): void {

            if (Model.Guard.isNothing(location) || Model.Guard.isNothing(location.newAddSmartCenterDetail))
                return;

            if (_.any(location.smartCenters, (sr) => { return sr.id === location.newAddSmartCenterDetail.id }))
                return;
            var maxIndex = Math.max.apply(Math, location.smartCenters.map(function (o) { return o.position; }));
            var smartCenterDetail: Model.SecurityRoleSmartCenterDataDetail = {
                ...location.newAddSmartCenterDetail,
                position: maxIndex + 1,
                objectState: Model.ObjectStateEnum.Active
            };
            location.smartCenters.push(smartCenterDetail);
            location.newAddSmartCenterDetail = undefined;

            location.smartCenters = this.updateSmartCenterList(location.smartCenters);

        }

        removeSmartCenter(location: any, index: number, item: any): void {

            if (Model.Guard.isSomething(location.smartCenters)) {
                var i = location.smartCenters.indexOf(item);

                if (i != -1) {
                    location.smartCenters.splice(i, 1);
                }
            }
            location.smartCenters = this.updateSmartCenterList(location.smartCenters);
        }

        updateSmartCenterList = (array: Model.ObjectStateDataDetail[]) => {
            array = _.sortBy(array, 'position');
            for (var a = 0; a < array.length; a++) {
                array[a].position = a + 1;
            }
            array = _.sortBy(array, (item: any) => { return item.position });

            return array;
        }

        switch = (index1: number, index2: number, location: Model.UserLocation) => {
            var array = location.smartCenters.filter(sc => !sc.role_TId);
            if (array[index1] && array[index2]) {
                var temp = array[index2];
                var position1 = array[index1].position;
                var position2 = array[index2].position;
                array[index2] = array[index1];
                array[index1] = temp;
                array[index1].position = position1;
                array[index2].position = position2;
            }
            location.smartCenters = this.updateSmartCenterList(location.smartCenters);
        }
        /* Add Location Groups */

        addLocationGroup(): void {
            if (Model.Guard.isNothing(this.newAddLocationGroupDetail))
                return;

            if (Model.Guard.isNothing(this.model.userLocationGroups))
                this.model.userLocationGroups = new Array<Model.UserLocationGroup>();

            let loc = _.find(this.model.userLocationGroups,
                (ug1) => { return ug1.locationGroup.id === this.newAddLocationGroupDetail.id });

            if (Model.Guard.isSomething(loc) && loc.locationGroup.objectState == Model.ObjectStateEnum.Inactive) {
                loc.locationGroup.objectState = Model.ObjectStateEnum.Active;

                return;
            }
            var ulg: Model.UserLocationGroup = {
                locationGroup: { id: this.newAddLocationGroupDetail.id.toString(), displayName: this.newAddLocationGroupDetail.displayName, businessTypeId: this.newAddLocationGroupDetail.businessTypeId, objectState: Model.ObjectStateEnum.Active },
                securityRoles: [],
                smartCenters: []
            };
            var locationGroupExists = _.find(this.model.userLocationGroups, (ulg) => { return ulg.locationGroup.id === this.newAddLocationGroupDetail.id });

            if (Model.Guard.isNothing(locationGroupExists))
                this.model.userLocationGroups.push(ulg);
            this.newAddLocationGroupDetail = undefined;
        }

        removeLocationGroup(index: number): void {
            if (Model.Guard.isSomething(this.model.userLocationGroups))
                this.model.userLocationGroups[index].locationGroup.objectState = Model.ObjectStateEnum.Inactive;
        }

        canRemoveLocation(loc: Model.UserLocationDetail, actingLocationId: number): boolean {
            return !(this.mode === Meevo.Model.MaintenanceFormState.Readonly) &&  //and must be in edit or add mode
                this.identityService.inCentralOfficeMode() &&  //must be in central office mode
                !loc.isHomeLocation &&   //cant remove the home location 
                loc.id != actingLocationId;  //cant remove itself 
        }

        checkHomeLocationId(asLocationId: number) {
            return (!!this.model && this.model.homeLocationId === asLocationId);
        }

        allowFullUserAccessChange(asLocationId: number): boolean {

            let isDisabled = !(this.mode === Meevo.Model.MaintenanceFormState.Readonly) && this.identityService.current().fullAccess && (this.identityService.inCentralOfficeMode() || this.identityService.current().isSingleLocation) && (this.checkHomeLocationId(asLocationId) || this.identityService.current().isSingleLocation);
            return isDisabled;
        }

        allowLocationFullAccess(locationId: number): boolean {

            if (this.identityService.current().fullAccess)
                return true;

            if (this.model.authFullAccessLocations != undefined && this.model.authFullAccessLocations.length > 0) {
                if (this.model.authFullAccessLocations.indexOf(locationId) > -1) {
                    return true;
                }
            }

            return false;

        }

        showFullUserAccess(): boolean {
            return (this.identityService.current().fullAccess);
        }

        disableSecurityField(asLocationId: number): boolean {
            return (!(this.mode === Meevo.Model.MaintenanceFormState.Readonly) && this.canEditSecurity(asLocationId));
        }

        canEditSecurity(asLocationId: number): boolean {
            return (this.identityService.inCentralOfficeMode() && this.checkHomeLocationId(asLocationId));
        }

        //User business Types
        addUserBusinessType(): void {

            if (Model.Guard.isNothing(this.newUserBuinessType))
                return;
            if (Model.Guard.isNothing(this.model.userBusinessTypes)) {
                this.model.userBusinessTypes = [];
            }

            if (_.any(this.model.userBusinessTypes, (ubt) => { return ubt.id === this.newUserBuinessType.id }))
                return;

            this.model.userBusinessTypes.push(this.newUserBuinessType);

            this.newUserBuinessType = undefined;

        }

        removeUserBusinessType(userSecurity: any, index: number): void {
            if (Model.Guard.isSomething(this.model.userBusinessTypes))
                this.model.userBusinessTypes.splice(index, 1);
        }

        checkSingleBusinessTypeInfo(): void {
            if (this.model.userBusinessTypes.length > 0) {
                this.checkBoxBusinessType = true;
            }
        }

        assignSingleBusinesstype(isChecked: boolean): void {
            if (isChecked) {
                this.model.userBusinessTypes.push(this.identityService.userBusinessTypes[0]);
            } else {
                this.model.userBusinessTypes.splice(0, 1);
            }
        }

        preSave(): void {
            super.preSave();
        }

        showUserBsinessType(location: any, asLocationId: number): boolean {
            if (asLocationId != this.model.homeLocationId) {
                return false;
            }
            return (this.identityService.inCentralOfficeMode() && ((location.location.id == this.identityService.current().centralOfficeId) && (this.identityService.tenantBusinessTypeCount > 1)));
        }

        showUserBsinessTypeCheckBox(location: any, asLocationId: number): boolean {
            if (asLocationId != this.model.homeLocationId) {
                return false;
            }
            if (this.identityService.tenantBusinessTypeCount == 1 && this.identityService.userBusinessTypes.length > 0)
                this.newUserBuinessType = this.identityService.userBusinessTypes[0];

            return (this.identityService.inCentralOfficeMode() && ((location.location.id == this.identityService.current().centralOfficeId) && (this.identityService.tenantBusinessTypeCount == 1)));
        }

        assignMeevoBISecurity(location: any) {
            if (location != null && location.location != null) {
                if (location.location.meevoBISecurityAccessCheckbox) {
                    location.location.meevoBISecurityAccess = Model.BISecurityAccessTypeEnum.FullLocation;
                }
                else {
                    location.location.meevoBISecurityAccess = Model.BISecurityAccessTypeEnum.None;
                }
            }
        }

        initializeMeevoBICheckbox(location: any) {
            if (location != null && location.location != null) {
                if (location.location.meevoBISecurityAccess == Model.BISecurityAccessTypeEnum.FullLocation) {
                    location.location.meevoBISecurityAccessCheckbox = true;
                }
                else {
                    location.location.meevoBISecurityAccessCheckbox = false;
                }
            }
        }
    }
}